import { render, staticRenderFns } from "./sortUp.vue?vue&type=template&id=0ab90360&scoped=true&"
import script from "./sortUp.vue?vue&type=script&lang=js&"
export * from "./sortUp.vue?vue&type=script&lang=js&"
import style0 from "./sortUp.vue?vue&type=style&index=0&id=0ab90360&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab90360",
  null
  
)

export default component.exports